import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    const exchange = async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/admin/login", { replace: true });
      }
    };
    exchange();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-navy-950 flex items-center justify-center">
      <p className="text-slate-400 text-sm tracking-widest uppercase">Memproses masuk...</p>
    </div>
  );
};
